// Atividades — sistema cross-módulo de tarefas atribuíveis a usuários.
// Entry point fino: orquestra o wrapper AntApp e delega para AtividadesInner.
// Re-exporta os helpers/tipos que outras páginas (NegocioDetalhe, etc) consomem.
import { App as AntApp } from 'antd';
import AtividadesInner from './atividades/AtividadesInner';
import ModalAtividade from './atividades/ModalAtividade';
import { STATUS_LABEL, PRIORIDADE_LABEL } from './atividades/types';
import type { Atividade, AtividadesProps } from './atividades/types';

export { ModalAtividade, STATUS_LABEL, PRIORIDADE_LABEL };
export type { Atividade };

export default function Atividades(props: AtividadesProps = {}) {
  return (
    <AntApp>
      <AtividadesInner {...props} />
    </AntApp>
  );
}
